import React from "react";
import PDCard from "../components/PDCard";
import { PITCHERS_SEASON_AGG } from "../data/pitchersSeasonAggregates";
import { getMockPitcherName } from "../utils/mockPlayerNames";
import { buildPitcherCard } from "../utils/pdBuilders";

const getTopPitchers = (data) => {
  // Create individualized pitcher profiles with realistic variety
  const pitcherProfiles = [
    {
      name: "Miguel Acosta",
      fbVelo: 97.8,
      whiffPct: 27.3,
      strikePct: 61.8,
      identityTag: "Power FB + Impact Arm Potential",
      tierLabel: "",
      strengths: [
        "Power FB, rides through zone, firm SL"
      ],
      improvements: [
        "Strike consistency, usable CH"
      ],
      goalsShort: [
        "Attack with first-pitch strikes, land SL in zone more often"
      ],
      goalsLong: [
        "Develop CH off FB, sustain swing-and-miss vs both sides"
      ],
      developmentTiles: [
        { label: "Strike Progress", value: "First-pitch strikes improving since delivery work" },
        { label: "Bullpen Focus", value: "Changeup development with grip refinement" },
        { label: "Early Fix", value: "Slider command improved through location work" }
      ]
    },
    {
      name: "Carlos Alvarez",
      fbVelo: 92.6,
      whiffPct: 26.7,
      strikePct: 67.8,
      identityTag: "Premium Velocity with Command Upside",
      tierLabel: "",
      strengths: [
        "Heavy sinker produces ground balls, bulldog makeup"
      ],
      improvements: [
        "Secondary sharpness, zone command"
      ],
      goalsShort: [
        "Fill the zone early, tighten SL execution"
      ],
      goalsLong: [
        "Add reliable CH, build starter durability"
      ],
      developmentTiles: [
        { label: "Command Progress", value: "Strike zone attack improved since mechanics work" },
        { label: "Bullpen Focus", value: "Secondary pitch development with spin work" },
        { label: "Early Fix", value: "Consistency improved through tempo adjustments" }
      ]
    },
    {
      name: "Alex Blair",
      fbVelo: 95.0,
      whiffPct: 33.5,
      strikePct: 63.2,
      identityTag: "High-Spin FB + Developing Arsenal",
      tierLabel: "",
      strengths: [
        "High-spin FB, deceptive look, competitive edge"
      ],
      improvements: [
        "CH consistency, maintain stuff vs. advanced hitters"
      ],
      goalsShort: [
        "More consistent SL, attack the zone with conviction"
      ],
      goalsLong: [
        "Reliable CH, multi-inning role potential"
      ],
      developmentTiles: [
        { label: "Changeup Progress", value: "Third pitch development showing improvement" },
        { label: "Bullpen Focus", value: "Changeup development with arm speed consistency" },
        { label: "Early Fix", value: "Breaking ball consistency improved through repetition" }
      ]
    }
  ];

  return pitcherProfiles.map(buildPitcherCard);
};

const PitcherDevelopmentPlans = () => {
  const pitchers = getTopPitchers(PITCHERS_SEASON_AGG);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-900 to-slate-900 text-white">
      {/* HEADER */}
      <div className="border-b border-white/10">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
          <h1 className="text-2xl font-bold tracking-tight text-white">⚡ Featured Pitcher Dev Notes</h1>
          <div className="text-sm text-white/70">Development Notes</div>
        </div>
      </div>

      {/* BODY */}
      <main className="mx-auto max-w-7xl px-6 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
          {pitchers.map((p, idx) => (
            <PDCard key={idx} player={p} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default PitcherDevelopmentPlans;
